export default "__VITE_ASSET__BB_u56_C__"